module.exports = __webpack_public_path__ + "static/media/S6_02.e8c961a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/STAGE6strobe/S6_02.png
// module id = 204
// module chunks = 0